if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends DetailsDisclosure {
      constructor() {
        super();

        this.elements = {
          shareButton: this.querySelector('button'),
          shareSummary: this.querySelector('summary'),
          closeButton: this.querySelector('.share-button__close'),
          successMessage: this.querySelector('[id^="ShareMessage"]'),
          urlInput: this.querySelector('input'),
        };
        this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;

        this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));
        this.mainDetailsToggle.querySelector('.share-button__copy').addEventListener('click', this.copyToClipboard.bind(this));
        this.elements.closeButton.addEventListener('click', this.close.bind(this));

        if (navigator.share && this.dataset.nativeShare !== 'false') {
          this.mainDetailsToggle.setAttribute('hidden', '');
          this.elements.shareButton.classList.remove('hidden');
          this.elements.shareButton.addEventListener('click', () => {
            Promise.resolve().then(() => navigator.share({ url: this.urlToShare, title: document.title })).catch((error) => {
              if (error?.name === 'AbortError') return;
              this.mainDetailsToggle.removeAttribute('hidden');
              this.elements.shareButton.classList.add('hidden');
              this.mainDetailsToggle.open = true;
              this.showCopyError();
            });
          });
        }
      }

      toggleDetails() {
        if (!this.mainDetailsToggle.open) {
          this.elements.successMessage.classList.add('hidden');
          this.elements.successMessage.textContent = '';
          this.elements.closeButton.classList.add('hidden');
          this.elements.shareSummary.focus();
        }
      }

      showCopyError() {
        this.elements.successMessage.classList.remove('hidden');
        this.elements.successMessage.textContent = window.accessibilityStrings.shareError;
        this.elements.closeButton.classList.add('hidden');
        this.elements.urlInput.focus();
        this.elements.urlInput.select();
      }

      copyToClipboard() {
        Promise.resolve().then(() => navigator.clipboard.writeText(this.elements.urlInput.value)).then(() => {
          this.elements.successMessage.classList.remove('hidden');
          this.elements.successMessage.textContent = window.accessibilityStrings.shareSuccess;
          this.elements.closeButton.classList.remove('hidden');
          this.elements.closeButton.focus();
        }).catch(() => this.showCopyError());
      }

      updateUrl(url) {
        this.urlToShare = url;
        if (this.elements.urlInput) this.elements.urlInput.value = url;
        this.querySelectorAll('.share-button__network').forEach((link) => {
          const target = new URL(link.href);
          const parameter = target.hostname.includes('facebook.com') ? 'u' : 'url';
          target.searchParams.set(parameter, url);
          link.href = target.href;
        });
      }
    }
  );
}
